import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6","key":"svg-0"}],["path",{"d":"M9 17h6","key":"svg-1"}],["path",{"d":"M19 16v3","key":"svg-2"}],["path",{"d":"M19 22v.01","key":"svg-3"}]]

const IconDeviceIpadHorizontalExclamation = createReactComponent('outline', 'device-ipad-horizontal-exclamation', 'DeviceIpadHorizontalExclamation', __iconNode);

export default IconDeviceIpadHorizontalExclamation;